import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, unref as _unref, vModelText as _vModelText, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/Front.png'
import _imports_1 from '@/assets/Back.png'
import _imports_2 from '@/assets/Left.png'
import _imports_3 from '@/assets/Right.png'


const _hoisted_1 = { class: "flex min-h-full items-center justify-center p-4" }
const _hoisted_2 = { class: "relative border border-gray-200 dark:border-gray-700 bg-white dark:bg-black rounded-lg shadow-xl max-w-2xl w-full max-h-[90vh] overflow-y-auto" }
const _hoisted_3 = { class: "mb-6" }
const _hoisted_4 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_5 = {
  key: 0,
  class: "mt-1 text-sm text-red-600 dark:text-red-400"
}
const _hoisted_6 = {
  key: 0,
  class: "mt-1 text-sm text-red-600 dark:text-red-400"
}
const _hoisted_7 = ["value"]
const _hoisted_8 = {
  key: 0,
  class: "mt-1 text-sm text-red-600 dark:text-red-400"
}
const _hoisted_9 = {
  key: 0,
  class: "mt-1 text-sm text-red-600 dark:text-red-400"
}
const _hoisted_10 = { class: "mb-6" }
const _hoisted_11 = { class: "grid grid-cols-2 sm:grid-cols-4 gap-6" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = {
  for: "photo_front",
  class: "cursor-pointer block"
}
const _hoisted_14 = {
  key: 0,
  class: "mt-1 text-xs text-red-600 dark:text-red-400"
}
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = {
  for: "photo_back",
  class: "cursor-pointer block"
}
const _hoisted_17 = {
  key: 0,
  class: "mt-1 text-xs text-red-600 dark:text-red-400"
}
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = {
  for: "photo_left",
  class: "cursor-pointer block"
}
const _hoisted_20 = {
  key: 0,
  class: "mt-1 text-xs text-red-600 dark:text-red-400"
}
const _hoisted_21 = { class: "text-center" }
const _hoisted_22 = {
  for: "photo_right",
  class: "cursor-pointer block"
}
const _hoisted_23 = {
  key: 0,
  class: "mt-1 text-xs text-red-600 dark:text-red-400"
}
const _hoisted_24 = {
  key: 0,
  class: "grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6"
}
const _hoisted_25 = {
  key: 0,
  class: "border-2 border-gray-200 dark:border-gray-600 rounded-lg p-4"
}
const _hoisted_26 = ["src"]
const _hoisted_27 = {
  key: 1,
  class: "border-2 border-gray-200 dark:border-gray-600 rounded-lg p-4"
}
const _hoisted_28 = ["src"]
const _hoisted_29 = {
  key: 2,
  class: "border-2 border-gray-200 dark:border-gray-600 rounded-lg p-4"
}
const _hoisted_30 = ["src"]
const _hoisted_31 = {
  key: 3,
  class: "border-2 border-gray-200 dark:border-gray-600 rounded-lg p-4"
}
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "flex items-center justify-end space-x-3 pt-4 border-t border-gray-200 dark:border-gray-700" }
const _hoisted_34 = ["disabled"]
const _hoisted_35 = ["disabled"]
const _hoisted_36 = {
  key: 0,
  class: "animate-spin -ml-1 mr-2 h-4 w-4 text-white",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

import { ref, computed } from 'vue';
import { useBrand } from '@/composables/brand/useBrand';
import type { VehicleFormData } from '@/types/vehicle';


export default /*@__PURE__*/_defineComponent({
  __name: 'AddVehicleModal',
  props: {
    isOpen: { type: Boolean },
    loading: { type: Boolean }
  },
  emits: ["close", "save"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const { brandColors } = useBrand();

const emit = __emit;

// Form data
const formData = ref<VehicleFormData>({
  vehicle_make: '',
  vehicle_model: '',
  vehicle_year: new Date().getFullYear(),
  plate_number: ''
});

// Vehicle photos - side-based structure
const sidePhotos = ref<Record<'front' | 'back' | 'left' | 'right', File | null>>({
  front: null,
  back: null,
  left: null,
  right: null
});

// Errors
const errors = ref<Record<string, string>>({});

// Year options (1900 to current year + 1)
const yearOptions = computed(() => {
  const currentYear = new Date().getFullYear();
  const years = [];
  for (let year = currentYear + 1; year >= 1900; year--) {
    years.push(year);
  }
  return years;
});

// Handle photo selection for specific side
function handlePhotoSelect(side: 'front' | 'back' | 'left' | 'right', event: Event) {
  const target = event.target as HTMLInputElement;
  if (target.files && target.files[0]) {
    const file = target.files[0];

    // Validate file type
    if (!['image/jpeg', 'image/png', 'image/jpg'].includes(file.type)) {
      errors.value[`photo_${side}`] = 'Only JPEG, PNG, and JPG files are allowed';
      return;
    }

    // Validate file size (5MB max)
    if (file.size > 5 * 1024 * 1024) {
      errors.value[`photo_${side}`] = 'File size must not exceed 5MB';
      return;
    }

    sidePhotos.value[side] = file;
    errors.value[`photo_${side}`] = '';
  }
}

// Remove photo for specific side
function removePhoto(side: 'front' | 'back' | 'left' | 'right') {
  sidePhotos.value[side] = null;
  errors.value[`photo_${side}`] = '';
}

// Get photo preview URL for specific side
function getPhotoPreview(side: 'front' | 'back' | 'left' | 'right'): string | null {
  const file = sidePhotos.value[side];
  return file ? URL.createObjectURL(file) : null;
}

// Check if any photos are selected
const hasSelectedPhotos = computed(() => {
  return Object.values(sidePhotos.value).some(photo => photo !== null);
});

function handleClose() {
  resetForm();
  emit('close');
}

function handleSubmit() {
  errors.value = {};

  // Validate that all 4 side photos are provided
  const sides = (['front', 'back', 'left', 'right'] as const);
  const sideLabels: Record<string, string> = {
    front: 'Front',
    back: 'Back',
    left: 'Side (Left)',
    right: 'Side (Right)',
  };
  let hasPhotoError = false;
  for (const side of sides) {
    if (!sidePhotos.value[side]) {
      errors.value[`photo_${side}`] = `${sideLabels[side]} photo is required`;
      hasPhotoError = true;
    }
  }
  if (hasPhotoError) return;

  // Build File array from non-null sides
  const photoFiles: File[] = [];
  const photoSides: string[] = [];

  Object.entries(sidePhotos.value).forEach(([side, file]) => {
    if (file) {
      photoFiles.push(file);
      photoSides.push(side);
    }
  });

  emit('save', { ...formData.value }, photoFiles, photoSides);
}

function resetForm() {
  formData.value = {
    vehicle_make: '',
    vehicle_model: '',
    vehicle_year: new Date().getFullYear(),
    plate_number: ''
  };
  sidePhotos.value = {
    front: null,
    back: null,
    left: null,
    right: null
  };
  errors.value = {};
}

// Expose resetForm so parent can call it
__expose({
  resetForm
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        (_ctx.isOpen)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-50 overflow-y-auto",
              onClick: _withModifiers(handleClose, ["self"])
            }, [
              _cache[38] || (_cache[38] = _createElementVNode("div", { class: "fixed inset-0 bg-black bg-opacity-50 transition-opacity" }, null, -1)),
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", { class: "sticky top-0 bg-white dark:bg-black border-b border-gray-200 dark:border-gray-700 px-6 py-4 flex items-center justify-between z-10" }, [
                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "flex items-center" }, [
                      _createElementVNode("div", { class: "flex-shrink-0 w-10 h-10 rounded-full bg-green-100 dark:bg-green-900/20 flex items-center justify-center mr-3" }, [
                        _createElementVNode("svg", {
                          class: "h-5 w-5 text-green-600 dark:text-green-400",
                          fill: "none",
                          viewBox: "0 0 24 24",
                          stroke: "currentColor"
                        }, [
                          _createElementVNode("path", {
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2",
                            d: "M12 4v16m8-8H4"
                          })
                        ])
                      ]),
                      _createElementVNode("h3", { class: "text-xl font-semibold text-gray-900 dark:text-white" }, " Add New Vehicle ")
                    ], -1)),
                    _createElementVNode("button", {
                      onClick: handleClose,
                      class: "text-gray-400 hover:text-gray-500 dark:hover:text-gray-300 transition-colors duration-200"
                    }, _cache[12] || (_cache[12] = [
                      _createElementVNode("svg", {
                        class: "h-6 w-6",
                        fill: "none",
                        viewBox: "0 0 24 24",
                        stroke: "currentColor"
                      }, [
                        _createElementVNode("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          "stroke-width": "2",
                          d: "M6 18L18 6M6 6l12 12"
                        })
                      ], -1)
                    ]))
                  ]),
                  _createElementVNode("form", {
                    onSubmit: _withModifiers(handleSubmit, ["prevent"]),
                    class: "px-6 py-4"
                  }, [
                    _createElementVNode("div", _hoisted_3, [
                      _cache[19] || (_cache[19] = _createElementVNode("h4", { class: "text-lg font-semibold text-gray-900 dark:text-white mb-4" }, "Vehicle Information", -1)),
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", null, [
                          _cache[14] || (_cache[14] = _createElementVNode("label", {
                            for: "vehicle_make",
                            class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                          }, [
                            _createTextVNode(" Vehicle Make "),
                            _createElementVNode("span", { class: "text-red-500" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "vehicle_make",
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.vehicle_make) = $event)),
                            type: "text",
                            placeholder: "e.g., Toyota, Honda, Ford",
                            required: "",
                            class: "w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-transparent bg-white dark:bg-black text-gray-900 dark:text-white",
                            style: _normalizeStyle({ borderColor: _unref(brandColors).primary, '--tw-ring-color': _unref(brandColors).primary, 'outline': 'none' })
                          }, null, 4), [
                            [_vModelText, formData.value.vehicle_make]
                          ]),
                          (errors.value.vehicle_make)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(errors.value.vehicle_make), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[15] || (_cache[15] = _createElementVNode("label", {
                            for: "vehicle_model",
                            class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                          }, [
                            _createTextVNode(" Vehicle Model "),
                            _createElementVNode("span", { class: "text-red-500" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "vehicle_model",
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.vehicle_model) = $event)),
                            type: "text",
                            placeholder: "e.g., Camry, Civic, F-150",
                            required: "",
                            class: "w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-transparent bg-white dark:bg-black text-gray-900 dark:text-white",
                            style: _normalizeStyle({ borderColor: _unref(brandColors).primary, '--tw-ring-color': _unref(brandColors).primary, 'outline': 'none' })
                          }, null, 4), [
                            [_vModelText, formData.value.vehicle_model]
                          ]),
                          (errors.value.vehicle_model)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(errors.value.vehicle_model), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[17] || (_cache[17] = _createElementVNode("label", {
                            for: "vehicle_year",
                            class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                          }, [
                            _createTextVNode(" Vehicle Year "),
                            _createElementVNode("span", { class: "text-red-500" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("select", {
                            id: "vehicle_year",
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.vehicle_year) = $event)),
                            required: "",
                            class: "w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-transparent bg-white dark:bg-black text-gray-900 dark:text-white",
                            style: _normalizeStyle({ borderColor: _unref(brandColors).primary, '--tw-ring-color': _unref(brandColors).primary, 'outline': 'none' })
                          }, [
                            _cache[16] || (_cache[16] = _createElementVNode("option", {
                              value: "",
                              disabled: ""
                            }, "Select year", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(yearOptions.value, (year) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: year,
                                value: year
                              }, _toDisplayString(year), 9, _hoisted_7))
                            }), 128))
                          ], 4), [
                            [
                              _vModelSelect,
                              formData.value.vehicle_year,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          (errors.value.vehicle_year)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(errors.value.vehicle_year), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", null, [
                          _cache[18] || (_cache[18] = _createElementVNode("label", {
                            for: "plate_number",
                            class: "block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2"
                          }, [
                            _createTextVNode(" Plate Number "),
                            _createElementVNode("span", { class: "text-red-500" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            id: "plate_number",
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.plate_number) = $event)),
                            type: "text",
                            placeholder: "e.g., ABC-1234",
                            required: "",
                            class: "w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 dark:focus:ring-blue-400 focus:border-transparent bg-white dark:bg-black text-gray-900 dark:text-white font-mono uppercase",
                            style: _normalizeStyle({ borderColor: _unref(brandColors).primary, '--tw-ring-color': _unref(brandColors).primary, 'outline': 'none' })
                          }, null, 4), [
                            [_vModelText, formData.value.plate_number]
                          ]),
                          (errors.value.plate_number)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(errors.value.plate_number), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _cache[36] || (_cache[36] = _createElementVNode("h4", { class: "text-lg font-semibold text-gray-900 dark:text-white mb-4" }, [
                        _createTextVNode(" Vehicle Photos "),
                        _createElementVNode("span", { class: "text-red-500" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("label", _hoisted_13, [
                            _createElementVNode("div", {
                              class: "border-2 border-dashed rounded-lg p-3 transition relative overflow-hidden",
                              style: _normalizeStyle({ backgroundColor: _unref(brandColors).primary })
                            }, _cache[20] || (_cache[20] = [
                              _createElementVNode("img", {
                                src: _imports_0,
                                alt: "Front View",
                                class: "w-full h-16 object-contain rounded"
                              }, null, -1)
                            ]), 4),
                            _cache[21] || (_cache[21] = _createElementVNode("p", { class: "mt-2 text-sm font-medium text-gray-700 dark:text-gray-300" }, [
                              _createTextVNode(" FRONT "),
                              _createElementVNode("span", { class: "text-red-500" }, "*")
                            ], -1))
                          ]),
                          _createElementVNode("input", {
                            id: "photo_front",
                            type: "file",
                            accept: "image/jpeg,image/png,image/jpg",
                            class: "hidden",
                            onChange: _cache[4] || (_cache[4] = ($event: any) => (handlePhotoSelect('front', $event)))
                          }, null, 32),
                          (errors.value.photo_front)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_14, _toDisplayString(errors.value.photo_front), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("label", _hoisted_16, [
                            _createElementVNode("div", {
                              class: "border-2 border-dashed rounded-lg p-3 transition relative overflow-hidden",
                              style: _normalizeStyle({ backgroundColor: _unref(brandColors).primary })
                            }, _cache[22] || (_cache[22] = [
                              _createElementVNode("img", {
                                src: _imports_1,
                                alt: "Back View",
                                class: "w-full h-16 object-contain rounded"
                              }, null, -1)
                            ]), 4),
                            _cache[23] || (_cache[23] = _createElementVNode("p", { class: "mt-2 text-sm font-medium text-gray-700 dark:text-gray-300" }, [
                              _createTextVNode(" BACK "),
                              _createElementVNode("span", { class: "text-red-500" }, "*")
                            ], -1))
                          ]),
                          _createElementVNode("input", {
                            id: "photo_back",
                            type: "file",
                            accept: "image/jpeg,image/png,image/jpg",
                            class: "hidden",
                            onChange: _cache[5] || (_cache[5] = ($event: any) => (handlePhotoSelect('back', $event)))
                          }, null, 32),
                          (errors.value.photo_back)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(errors.value.photo_back), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("label", _hoisted_19, [
                            _createElementVNode("div", {
                              class: "border-2 border-dashed rounded-lg p-3 transition relative overflow-hidden",
                              style: _normalizeStyle({ backgroundColor: _unref(brandColors).primary })
                            }, _cache[24] || (_cache[24] = [
                              _createElementVNode("img", {
                                src: _imports_2,
                                alt: "Left View",
                                class: "w-full h-16 object-contain rounded"
                              }, null, -1)
                            ]), 4),
                            _cache[25] || (_cache[25] = _createElementVNode("p", { class: "mt-2 text-sm font-medium text-gray-700 dark:text-gray-300" }, [
                              _createTextVNode(" SIDE (L) "),
                              _createElementVNode("span", { class: "text-red-500" }, "*")
                            ], -1))
                          ]),
                          _createElementVNode("input", {
                            id: "photo_left",
                            type: "file",
                            accept: "image/jpeg,image/png,image/jpg",
                            class: "hidden",
                            onChange: _cache[6] || (_cache[6] = ($event: any) => (handlePhotoSelect('left', $event)))
                          }, null, 32),
                          (errors.value.photo_left)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(errors.value.photo_left), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("label", _hoisted_22, [
                            _createElementVNode("div", {
                              class: "border-2 border-dashed rounded-lg p-3 transition relative overflow-hidden",
                              style: _normalizeStyle({ backgroundColor: _unref(brandColors).primary })
                            }, _cache[26] || (_cache[26] = [
                              _createElementVNode("img", {
                                src: _imports_3,
                                alt: "Right View",
                                class: "w-full h-16 object-contain rounded"
                              }, null, -1)
                            ]), 4),
                            _cache[27] || (_cache[27] = _createElementVNode("p", { class: "mt-2 text-sm font-medium text-gray-700 dark:text-gray-300" }, [
                              _createTextVNode(" SIDE (R) "),
                              _createElementVNode("span", { class: "text-red-500" }, "*")
                            ], -1))
                          ]),
                          _createElementVNode("input", {
                            id: "photo_right",
                            type: "file",
                            accept: "image/jpeg,image/png,image/jpg",
                            class: "hidden",
                            onChange: _cache[7] || (_cache[7] = ($event: any) => (handlePhotoSelect('right', $event)))
                          }, null, 32),
                          (errors.value.photo_right)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(errors.value.photo_right), 1))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      (hasSelectedPhotos.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            (sidePhotos.value.front)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                  _cache[29] || (_cache[29] = _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2" }, "FRONT", -1)),
                                  _createElementVNode("img", {
                                    src: getPhotoPreview('front')!,
                                    alt: "Front preview",
                                    class: "w-full h-40 object-cover rounded-lg mb-3"
                                  }, null, 8, _hoisted_26),
                                  _createElementVNode("button", {
                                    type: "button",
                                    onClick: _cache[8] || (_cache[8] = ($event: any) => (removePhoto('front'))),
                                    class: "w-full px-3 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg text-sm font-medium transition-colors flex items-center justify-center gap-2"
                                  }, _cache[28] || (_cache[28] = [
                                    _createElementVNode("svg", {
                                      class: "w-4 h-4",
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }, [
                                      _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                      })
                                    ], -1),
                                    _createTextVNode(" Remove ")
                                  ]))
                                ]))
                              : _createCommentVNode("", true),
                            (sidePhotos.value.back)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                  _cache[31] || (_cache[31] = _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2" }, "BACK", -1)),
                                  _createElementVNode("img", {
                                    src: getPhotoPreview('back')!,
                                    alt: "Back preview",
                                    class: "w-full h-40 object-cover rounded-lg mb-3"
                                  }, null, 8, _hoisted_28),
                                  _createElementVNode("button", {
                                    type: "button",
                                    onClick: _cache[9] || (_cache[9] = ($event: any) => (removePhoto('back'))),
                                    class: "w-full px-3 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg text-sm font-medium transition-colors flex items-center justify-center gap-2"
                                  }, _cache[30] || (_cache[30] = [
                                    _createElementVNode("svg", {
                                      class: "w-4 h-4",
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }, [
                                      _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                      })
                                    ], -1),
                                    _createTextVNode(" Remove ")
                                  ]))
                                ]))
                              : _createCommentVNode("", true),
                            (sidePhotos.value.left)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                  _cache[33] || (_cache[33] = _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2" }, "SIDE (L)", -1)),
                                  _createElementVNode("img", {
                                    src: getPhotoPreview('left')!,
                                    alt: "Left preview",
                                    class: "w-full h-40 object-cover rounded-lg mb-3"
                                  }, null, 8, _hoisted_30),
                                  _createElementVNode("button", {
                                    type: "button",
                                    onClick: _cache[10] || (_cache[10] = ($event: any) => (removePhoto('left'))),
                                    class: "w-full px-3 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg text-sm font-medium transition-colors flex items-center justify-center gap-2"
                                  }, _cache[32] || (_cache[32] = [
                                    _createElementVNode("svg", {
                                      class: "w-4 h-4",
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }, [
                                      _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                      })
                                    ], -1),
                                    _createTextVNode(" Remove ")
                                  ]))
                                ]))
                              : _createCommentVNode("", true),
                            (sidePhotos.value.right)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                  _cache[35] || (_cache[35] = _createElementVNode("p", { class: "text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2" }, "SIDE (R)", -1)),
                                  _createElementVNode("img", {
                                    src: getPhotoPreview('right')!,
                                    alt: "Right preview",
                                    class: "w-full h-40 object-cover rounded-lg mb-3"
                                  }, null, 8, _hoisted_32),
                                  _createElementVNode("button", {
                                    type: "button",
                                    onClick: _cache[11] || (_cache[11] = ($event: any) => (removePhoto('right'))),
                                    class: "w-full px-3 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg text-sm font-medium transition-colors flex items-center justify-center gap-2"
                                  }, _cache[34] || (_cache[34] = [
                                    _createElementVNode("svg", {
                                      class: "w-4 h-4",
                                      fill: "none",
                                      viewBox: "0 0 24 24",
                                      stroke: "currentColor"
                                    }, [
                                      _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        "stroke-width": "2",
                                        d: "M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                      })
                                    ], -1),
                                    _createTextVNode(" Remove ")
                                  ]))
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("button", {
                        type: "button",
                        onClick: handleClose,
                        disabled: _ctx.loading,
                        class: "px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors duration-200 font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                      }, " Cancel ", 8, _hoisted_34),
                      _createElementVNode("button", {
                        type: "submit",
                        disabled: _ctx.loading,
                        class: "px-4 py-2 text-white rounded-lg transition-all duration-200 font-medium disabled:opacity-50 disabled:cursor-not-allowed flex items-center shadow-lg hover:shadow-xl transform hover:-translate-y-0.5",
                        style: _normalizeStyle({ backgroundColor: _unref(brandColors).primary })
                      }, [
                        (_ctx.loading)
                          ? (_openBlock(), _createElementBlock("svg", _hoisted_36, _cache[37] || (_cache[37] = [
                              _createElementVNode("circle", {
                                class: "opacity-25",
                                cx: "12",
                                cy: "12",
                                r: "10",
                                stroke: "currentColor",
                                "stroke-width": "4"
                              }, null, -1),
                              _createElementVNode("path", {
                                class: "opacity-75",
                                fill: "currentColor",
                                d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                              }, null, -1)
                            ])))
                          : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(_ctx.loading ? 'Adding...' : 'Add Vehicle'), 1)
                      ], 12, _hoisted_35)
                    ])
                  ], 32)
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})